import type { ReactNode } from 'react';

export const symbol_subdirectory_arrow_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M535-163q0-12 9-21l141-141H260q-24.75 0-42.37-17.63Q200-360.25 200-385v-385q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v385h426L546-525q-9-9-9-21.5t8.61-21.5q9.39-9 21.39-9.5t21 8.5l191 191q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L587-142q-9.07 9-21.53 9-12.47 0-21.47-9-9-9-9-21Z"
		/>
	</svg>
);
